import React from "react";
import moment from "moment";
import { Box, Flex, Text } from "rebass";

import { EntryType } from "../../types";
import { FileActionIcon } from "./FileActionIcon";
import { FileIcon } from "./FileIcon";
import { FolderActionIcon } from "./FolderActionIcon";

import { nFormatter } from "../../../../../utils/nFormatter";

interface IProps {
  name: string;
  type: EntryType;
  createdTime?: string;
  size?: number;
  checked: boolean;
}

export const FileItem: React.FC<IProps> = (
  {
    name,
    type,
    createdTime,
    size,
    checked,
  }
) => (
  <Flex
    alignItems="center"
    p="11px"
    pr="20px"
  >
    <Flex width="64px" justifyContent="center">
      <FileIcon type={type} />
    </Flex>

    <Box flex={1} mr="16px" css="overflow: hidden;">
      <Text
        fontSize="16px"
        fontWeight={600}
        lineHeight={1.19}
        textAlign="left"
        color="zodiac"
        css="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
      >
        {name}
      </Text>

      <Text
        mt="4px"
        fontSize="14px"
        fontWeight={600}
        lineHeight={1.36}
        textAlign="left"
        color="wild-blue"
      >
        <span>{moment(createdTime).format("L")}</span>

        {size && (
          <span>{` - ${nFormatter(size, 0)}B`}</span>
        )}
      </Text>
    </Box>

    {
      type === "folder"
        ? <FolderActionIcon />
        : <FileActionIcon checked={checked} />
    }
  </Flex>
);
